import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from '../layout';
import AvatarPage from './pages/Avatar/AvatarPage';
import routes from './routs';

export function App() {
  return (
    <Routes>
      <Route path={routes.home} element={<Layout />}>
        <Route index element={<AvatarPage />} />
        <Route path="*" element={<Navigate replace to={routes.home} />} />
      </Route>
    </Routes>
  );
}

export default App;
